export default function Benefits({ benefits }) {
  if (!benefits.length) return null;

  return (
    <section className="section section-alt benefits" style={{ marginTop: 60 }}>
      <div className="wrap">
        <p className="eyebrow">Weshalb der Aufwand sich lohnt</p>
        <h2>Ein Abend im Monat, der dir eine Fehlentscheidung erspart.</h2>
        <p className="section-lead" style={{ marginBottom: 48 }}>
          Kein Referat, kein Verkaufsstand. Wer kommt, bringt eine offene Frage mit und nimmt drei
          Antworten mit nach Hause.
        </p>

        <div className="benefit-grid">
          {benefits.map((b) => (
            <article className="benefit" key={b.id}>
              <h3>{b.title}</h3>
              <p>{b.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
